module.exports = __webpack_public_path__ + "img/Infografis_EN_19.37818b7a.jpg";